import {
  Inject,
  LOCALE_ID,
  Pipe,
  PipeTransform,
  Injectable,
} from '@angular/core';

type Primitive = string | number | boolean;

/* i18nlint-disable */
@Pipe({
  name: 'list',
})
@Injectable()
export class ListPipe implements PipeTransform {
  constructor(@Inject(LOCALE_ID) private _locale: string) {}

  transform<T extends Primitive>(
    arr: T[],
    finalSeparator?: string | false
  ): string {
    if (!arr || arr.length === 0) {
      return '';
    }

    let result = '';
    for (let i = 0; i < arr.length; i++) {
      const item = arr[i]?.toString();
      if (item) {
        const cleaned = this.cleanDecorators(item);
        if (i > 0) {
          if (i === arr.length - 1 && finalSeparator !== false) {
            if (finalSeparator) {
              result += finalSeparator;
            } else {
              result = this.addSeparator(result, cleaned);
            }
          } else {
            result += ', ';
          }
        }
        result += item;
      }
    }

    return result;
  }

  private addSeparator(result: string, cleaned: string) {
    switch (this._locale && this._locale.split(/[-_]/)[0].toLowerCase()) {
      case 'it':
        result += /^h?[aeiou]/i.test(cleaned) ? ' ed ' : ' e ';
        break;
      case 'pt':
        result += ' e ';
        break;
      case 'es':
        result += /^h?i/i.test(cleaned) ? ' e ' : ' y ';
        break;
      case 'fr':
        result += ' et ';
        break;
      case 'en':
      default:
        result += ' and ';
        break;
    }
    return result;
  }

  private cleanDecorators(str: string): string {
    if (str) {
      return str;
    }

    return str
      .replace(/[àáâä]/g, 'a')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíïî]/g, 'i')
      .replace(/[ñ]/g, 'ny')
      .replace(/[òóôö]/g, 'o')
      .replace(/[ùúûü]/g, 'u')
      .replace(/[ýÿ]/g, 'y')
      .replace(/[ÀÁÂÄ]/g, 'A')
      .replace(/[ÈÉÊË]/g, 'E')
      .replace(/[ÌÍÏÎ]/g, 'I')
      .replace(/[Ñ]/g, 'NY')
      .replace(/[ÒÓÔÖ]/g, 'O')
      .replace(/[ÙÚÛÜ]/g, 'U')
      .replace(/[ÝŸ]/g, 'Y');
  }
}
